@if (isLoading) {
  <app-loader></app-loader>
} @else if (dataSource.data.length > 0) {
  <div class="user-property-list-table-container">
  <div class="mat-elevation-z8 hide-on-mobile">
    
    <mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </mat-header-cell>
          <mat-cell *matCellDef="let user" [class.unverified]="!user.isVerified"> 
              {{ user.lastName || '' }}
          </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="firstName">
            <mat-header-cell *matHeaderCellDef mat-sort-header> First Name </mat-header-cell>
            <mat-cell *matCellDef="let user" [class.unverified]="!user.isVerified"> {{ user.firstName ?? '' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="username">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Username </mat-header-cell>
          <mat-cell *matCellDef="let user" [class.unverified]="!user.isVerified">
            {{ user.username || '' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="role">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Last Updated </mat-header-cell>
            <mat-cell *matCellDef="let user"> {{ user.role ?? ''}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Id </mat-header-cell>
            <mat-cell *matCellDef="let user"> 
              {{ user.id || '' }}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="stripeId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Stripe Id </mat-header-cell>
            <mat-cell *matCellDef="let user"> 
              {{ user.stripeUserId || '' }}
            </mat-cell>
        </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    
  </div>

  <div class="mobile-property-list show-on-mobile" *ngIf="!isLoading">
    <mat-card *ngFor="let user of dataSource.connect() | async" class="mobile-property-card">
      <mat-card-header>
        <mat-card-title [class.unverified]="!user.isVerified">{{ user.firstName || '' }} {{ user.lastName || '' }} </mat-card-title>
        
      </mat-card-header>
      <mat-card-content style="text-align: left">
        <div>Username: {{ user?.username }}</div>
        <div>Role: {{ user?.role ?? '' }}</div>
        <div>Id: {{ user?.id }}</div>
        <div *ngIf="user?.stripeUserId">Stripe Id: {{ user?.stripeUserId }}</div>
      </mat-card-content>
    </mat-card>
  </div>
  <mat-paginator 
      #paginator
      [pageSizeOptions]="[5,10, 25, 100]"
      aria-label="Select page of forms">
    </mat-paginator>
  </div>
} @else {
  <p>No terms forms found</p>
}